/**
 * @format
 * @flow
 */
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as Actions from '../../actions/App';
import Template from '../../components/Template/AfterLoginTemplate';
import { loadStart, loadEnd } from '../../actions/App';
import { Link } from 'react-router-dom';
import * as RT from '../../constants/Routing';
const Moment = require('moment');

class Component extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      notification: this.props.App.notification
    };
    this.currentUser = JSON.parse(localStorage.getItem('current_user'));
  }

  componentDidMount() {
    loadStart();
    const token = this.currentUser.accessToken;
    const { enterpriseId } = this.currentUser;
    this.props.getNotification(enterpriseId, token);
  }

  componentWillReceiveProps = props => {
    if (!this.props.App.loading) {
      console.log('TCL: Component -> props', props);
      this.setState({ notification: this.props.App.notification });
    }
  };

  updateNotification = item => {
    loadStart();
    const token = this.currentUser.accessToken;
    const { enterpriseId } = this.currentUser;
    this.props.updateNotification(enterpriseId, item.notificationId, token);
  };

  render = () => {
    return (
      <Template>
        <div className="">
          <h2>お知らせ</h2>
          <div className="row">
            <div className="form-group position-relative col-12">
              <div className="notification-list">
                {this.state.notification.map((item, index) => {
                  return (
                    <ul>
                      <li>
                        <h3>
                          <i
                            class={
                              item.type === 'Handshake'
                                ? 'far fa-handshake match-notification'
                                : 'fas fa-bell sys-notification'
                            }
                          ></i>
                          <span>
                            <Link
                              className=""
                              to={RT.TASK_SHOW_PATH.replace(/:task_id/, item.taskId)}
                            >
                              {item.description}
                            </Link>
                            <span>
                              <h6>{new Moment(item.createDate).format('MM月DD日 hh時mm分')}</h6>
                            </span>
                          </span>
                        </h3>
                        <span className="noti-close">
                          <i
                            class="far fa-times-circle"
                            onClick={() => {
                              this.updateNotification(item);
                            }}
                          ></i>
                        </span>
                      </li>
                    </ul>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </Template>
    );
  };
}

const mapStateToProps = state => state;
const mapDispatchToProps = dispatch => bindActionCreators(Actions, dispatch);

const Container = connect(mapStateToProps, mapDispatchToProps)(Component);

export default withRouter(Container);
